export default "__VITE_ASSET__DyYONXxD__"